export default __webpack_public_path__ + "images/UG.cf72d91.png";